import API from './config'

export const TitleAPI = {

    async createTitle(title) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/create', title, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateTitle(title) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/titles/update', title, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async createTitleType(titleType) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/createTitleType', titleType, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateTitleType(titleType) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/titles/updateTitleType', titleType, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async deleteTitle(titleId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.delete('/titles/delete/' + titleId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllTitles() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/titles/listAllTitles', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getTitlesBySearch(search) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {
            const response = await API.get('/titles/getTitlesBySearch?search=' + search, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getTitleTypes() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/titles/getTitleTypes', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async createAssetTitle(assetTitle) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/createAssetTitle', assetTitle, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateAssetTitle(assetTitle) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/titles/updateAssetTitle', assetTitle, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateAccountAssetTitle(assetTitleId, newAccountId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.patch('/titles/updateAccountAssetTitle/' + assetTitleId,
                { new_account_id: newAccountId },
                config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateTradingNoteAssetTitle(assetTitleId, newTradingNote) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.patch('/titles/updateTradingNoteAssetTitle/' + assetTitleId, { new_trading_note: newTradingNote }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateEletronicAquisitionAssetTitle(assetTitleId, newValue) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.patch('/titles/updateEletronicAquisitionAssetTitle/' + assetTitleId, { new_eletronic_aquisition: newValue }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async deleteAssetTitle(assetTitleId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.delete('/titles/deleteAssetTitle/' + assetTitleId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllClientTitles(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/titles/getAllClientTitles/' + clientId,
                config
            )

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getTitlesByIds(titlesIds) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/getTitlesByIds',
                { titles_ids: titlesIds },
                config
            )

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getTitleClientAccountList(titleId, clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/getTitleClientAccountList', {
                title_id: titleId,
                client_id: clientId,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientAssetsTitles(year, client_id, regime, removeGenerics, justGenerics) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/getClientAssetsTitles',
                { year, client_id, regime, remove_generics: removeGenerics, just_generics: justGenerics },
                config
            )

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientAllAssetsTitleByDateAndRegime(clientId, startDate, endDate, accountRegimeId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/getClientAllAssetsTitleByDateAndRegime', {
                client_id: clientId,
                start_date: startDate,
                end_date: endDate,
                account_regime_id: accountRegimeId,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAmortizationsByTitleAssetsIds(idsInClause, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/getAmortizationsByTitleAssetsIds', {
                in_clause: idsInClause,
                end_date: endDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getTransactionsByAssetsTitlesIdsAndPeriod(idsInClause, startDate, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/getTransactionsByAssetsTitlesIdsAndPeriod', {
                title_assets_ids: idsInClause,
                start_date: startDate,
                end_date: endDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientAllAssetsTitleByDateAndRegimeWithInits(clientId, startDate, endDate, accountRegimeId, isPeriodQuery) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/getClientAllAssetsTitleByDateAndRegimeWithInits', {
                client_id: clientId,
                start_date: startDate,
                end_date: endDate,
                account_regime_id: accountRegimeId,
                is_period_query: isPeriodQuery,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveCoupon(coupon) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/saveCoupon', coupon, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getBalancesByMonthAndYear(clientId, month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/titles/getBalancesByMonthAndYear?client_id=${clientId}&month=${month}&year=${year}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getBalancesByPeriod(clientId, startDate, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/titles/getBalancesByPeriod?client_id=${clientId}&start_date=${startDate}&end_date=${endDate}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getCouponsByTitleIdAndYear(titleId, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/getCouponsByTitleIdAndYear', {
                title_id: titleId, year: year,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getTitleArticles(titleId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/titles/getArticles?title_id=${titleId}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },


    async updateTitleArticles(titleId, titleArticles) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post(`/titles/updateTitleArticles`,
                { title_id: titleId, title_articles: titleArticles, },
                config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getArticlesWithEletronic(titleId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/titles/getArticlesWithEletronic?title_id=' + titleId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async addEletronicAquisitionClient(data) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/titles/addEletronicAquisitionClient', data, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async removeEletronicAquisitionClient(id) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.delete('/titles/removeEletronicAquisitionClient/' + id, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },
}

